import { Component } from '@angular/core';

@Component({
    selector: '[apPanelHeader]',
    template: '<ng-content></ng-content>',
    host: {
        class: 'ap-panel__header--title'
    }
})
export class ApPanelHeaderDirective {}
